export const INPUT_KEY_BACKSPACE = 'Backspace';
